// Publication year filter: options (All Time, Current year, 2/5/10 years, Custom) + custom min/max inputs

const ALL_TIME_YEAR = 1800;

export function initializePublicationYearFilter() {
    const radios = document.querySelectorAll('input[name="pubYearRange"]');
    const customSection = document.getElementById('pubYearCustomSection');
    const customMin = document.getElementById('pubYearCustomMin');
    const customMax = document.getElementById('pubYearCustomMax');

    if (!radios.length || !customSection || !customMin || !customMax) {
        return;
    }

    const currentYear = new Date().getFullYear();

    function getRangeFromPreset(preset) {
        switch (preset) {
            case 'all':
                return { start: ALL_TIME_YEAR, end: currentYear };
            case '1':
                return { start: currentYear, end: currentYear };
            case '5':
                return { start: currentYear - 4, end: currentYear };
            case '10':
                return { start: currentYear - 9, end: currentYear };
            default:
                return null;
        }
    }

    function getPresetFromRange(start, end) {
        if (start === ALL_TIME_YEAR && end === currentYear) return 'all';
        if (start === currentYear && end === currentYear) return '1';
        if (start === currentYear - 4 && end === currentYear) return '5';
        if (start === currentYear - 9 && end === currentYear) return '10';
        return 'custom';
    }

    function updateCustomVisibility() {
        const customRadio = document.querySelector('input[name="pubYearRange"][value="custom"]');
        if (customRadio && customRadio.checked) {
            customSection.classList.remove('hidden');
        } else {
            customSection.classList.add('hidden');
        }
    }

    radios.forEach((radio) => {
        radio.addEventListener('change', updateCustomVisibility);
    });

    updateCustomVisibility();

    const MIN_YEAR = 1800;

    function validateCustomYears() {
        const checked = document.querySelector('input[name="pubYearRange"]:checked');
        if (!checked || checked.value !== 'custom') return null;

        const minRaw = customMin.value.trim();
        const maxRaw = customMax.value.trim();
        if (!minRaw || !maxRaw) return 'Please enter both min and max year.';

        const min = parseInt(customMin.value, 10);
        const max = parseInt(customMax.value, 10);
        if (Number.isNaN(min) || Number.isNaN(max)) return 'Please enter valid numbers.';
        if (min < MIN_YEAR || min > currentYear) return `Min year must be between ${MIN_YEAR} and ${currentYear}.`;
        if (max < MIN_YEAR || max > currentYear) return `Max year must be between ${MIN_YEAR} and ${currentYear}.`;
        if (min > max) return 'Min year cannot be greater than max year.';
        return null;
    }

    window.getPublicationYearCustomValidationError = validateCustomYears;

    window.getPublicationYearSliderValues = () => {
        const checked = document.querySelector('input[name="pubYearRange"]:checked');
        const value = checked ? checked.value : 'all';

        if (value === 'custom') {
            const min = parseInt(customMin.value, 10);
            const max = parseInt(customMax.value, 10);
            const start = Number.isNaN(min) ? MIN_YEAR : Math.max(MIN_YEAR, Math.min(min, currentYear));
            const end = Number.isNaN(max) ? currentYear : Math.max(MIN_YEAR, Math.min(max, currentYear));
            return { start: start > end ? end : start, end: start > end ? start : end };
        }

        const range = getRangeFromPreset(value);
        return range || { start: ALL_TIME_YEAR, end: currentYear };
    };

    window.setPublicationYearSliderValues = (start, end) => {
        const preset = getPresetFromRange(start, end);
        const radio = document.querySelector(`input[name="pubYearRange"][value="${preset}"]`);
        if (radio) {
            radio.checked = true;
        }
        if (preset === 'custom') {
            customMin.value = start;
            customMax.value = end;
            customSection.classList.remove('hidden');
        } else {
            customSection.classList.add('hidden');
        }
    };

    // Set min/max attrs for custom inputs
    customMin.min = MIN_YEAR;
    customMin.max = currentYear;
    customMax.min = MIN_YEAR;
    customMax.max = currentYear;

    // Clamp and validate on input: keep years in range, ensure min <= max
    function clampCustomInputs() {
        const minVal = parseInt(customMin.value, 10);
        const maxVal = parseInt(customMax.value, 10);
        if (Number.isNaN(minVal) && Number.isNaN(maxVal)) return;

        const clampedMin = Number.isNaN(minVal) ? MIN_YEAR : Math.max(MIN_YEAR, Math.min(minVal, currentYear));
        const clampedMax = Number.isNaN(maxVal) ? currentYear : Math.max(MIN_YEAR, Math.min(maxVal, currentYear));

        if (!Number.isNaN(minVal) && minVal !== clampedMin) customMin.value = clampedMin;
        if (!Number.isNaN(maxVal) && maxVal !== clampedMax) customMax.value = clampedMax;

        const finalMin = Number.isNaN(minVal) ? MIN_YEAR : clampedMin;
        const finalMax = Number.isNaN(maxVal) ? currentYear : clampedMax;
        if (finalMin > finalMax) {
            if (document.activeElement === customMin) customMax.value = finalMin;
            else customMin.value = finalMax;
        }
    }

    customMin.addEventListener('blur', clampCustomInputs);
    customMax.addEventListener('blur', clampCustomInputs);
}
